
import { useState, useEffect, useCallback } from "react";

const API = "https://scraps-backend.onrender.com";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&display=swap');
  :root {
    --bg: #0a0e1a; --surface: #111827; --surface2: #1a2235; --surface3: #1f2d42;
    --border: rgba(255,255,255,0.07); --border2: rgba(255,255,255,0.14);
    --accent: #3d9e7a; --accent-dim: rgba(61,158,122,0.12); --accent-dim2: rgba(61,158,122,0.22);
    --gold: #f5b731; --gold-dim: rgba(245,183,49,0.12);
    --red: #ff4d6d; --red-dim: rgba(255,77,109,0.12);
    --blue: #4d9fff; --blue-dim: rgba(77,159,255,0.12);
    --text: #f0f4ff; --text2: #8a96b0; --text3: #4a5568;
    --radius: 10px; --radius-sm: 6px;
    --slip-bg: #ffffff; --slip-border: #e5e7eb; --slip-text: #1a1a2e; --slip-sub: #6b7280;
    --slip-item-bg: #1a2235;
  }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', sans-serif; background: var(--bg); color: var(--text); min-height: 100vh; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: var(--border2); border-radius: 4px; }
  @keyframes fadeIn { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }
  @keyframes pulse { 0%,100% { opacity:1; } 50% { opacity:0.4; } }
  @keyframes slideIn { from { transform:translateX(20px); opacity:0; } to { transform:translateX(0); opacity:1; } }
  @keyframes popIn { from { opacity:0; transform:scale(0.95); } to { opacity:1; transform:scale(1); } }
  .bet-slip-panel { background: #ffffff !important; background-color: #ffffff !important; }
  .bet-slip-header { background: #ffffff !important; background-color: #ffffff !important; border-bottom: 1px solid #e5e7eb !important; }
  .bet-slip-content { background: #ffffff !important; background-color: #ffffff !important; }
  .bet-slip-footer { background: #f9fafb !important; background-color: #f9fafb !important; border-top: 1px solid #e5e7eb !important; }
  .bet-slip-panel .bet-slip-title { color: #1a1a2e !important; }
  .bet-slip-panel .bet-slip-sub { color: #6b7280!important; }
  @media (max-width: 768px) {
    .desktop-only { display: none !important; }
    .mobile-full { width: 100% !important; }
    .game-grid { grid-template-columns: 1fr !important; }
    .bet-slip-mobile { position: fixed; bottom: 0; left: 0; right: 0; z-index: 50; max-height: 60vh; overflow-y: auto; border-top: 1px solid var(--border2); }
  }
`;

const ALL_SPORTS_CONFIG = [
  { key:"americanfootball_nfl",      label:"NFL",               emoji:"🏈" },
  { key:"americanfootball_ncaaf",    label:"NCAAF",             emoji:"🏈" },
  { key:"basketball_nba",            label:"NBA",               emoji:"🏀" },
  { key:"basketball_ncaab",          label:"NCAAB",             emoji:"🏀" },
  { key:"basketball_wnba",           label:"WNBA",              emoji:"🏀" },
  { key:"baseball_mlb",              label:"MLB",               emoji:"⚾" },
  { key:"icehockey_nhl",             label:"NHL",               emoji:"🏒" },
  { key:"soccer_epl",                label:"EPL",               emoji:"⚽" },
  { key:"soccer_uefa_champs_league", label:"UCL",               emoji:"⚽" },
  { key:"soccer_usa_mls",            label:"MLS",               emoji:"⚽" },
  { key:"soccer_germany_bundesliga", label:"Bundesliga",        emoji:"⚽" },
  { key:"soccer_spain_la_liga",      label:"La Liga",           emoji:"⚽" },
  { key:"soccer_italy_serie_a",      label:"Serie A",           emoji:"⚽" },
  { key:"soccer_france_ligue_one",   label:"Ligue 1",           emoji:"⚽" },
  { key:"tennis_atp_french_open",    label:"Tennis",            emoji:"🎾" },
  { key:"mma_mixed_martial_arts",    label:"MMA",               emoji:"🥊" },
  { key:"golf_pga_tour",             label:"Golf",              emoji:"⛳" },
  { key:"motorsport_formula_1",      label:"F1/NASCAR",         emoji:"🏎" },
];

const SPORTS = [
  { key: "americanfootball_nfl", label: "NFL", emoji: "🏈" },
  { key: "basketball_nba", label: "NBA", emoji: "🏀" },
  { key: "baseball_mlb", label: "MLB", emoji: "⚾" },
  { key: "icehockey_nhl", label: "NHL", emoji: "🏒" },
];

const MOCK_GAMES = {
  americanfootball_nfl: [
    { id:"nfl_001", sport:"NFL", commence_time: new Date(Date.now()+3600000*2).toISOString(), home_team:"Kansas City Chiefs", away_team:"Buffalo Bills", bookmakers:[{markets:[
      {key:"spreads",outcomes:[{name:"Kansas City Chiefs",price:-110,point:-3.5},{name:"Buffalo Bills",price:-110,point:3.5}]},
      {key:"totals",outcomes:[{name:"Over",price:-108,point:47.5},{name:"Under",price:-112,point:47.5}]},
      {key:"h2h",outcomes:[{name:"Kansas City Chiefs",price:-175},{name:"Buffalo Bills",price:148}]}
    ]}]},
    { id:"nfl_002", sport:"NFL", commence_time: new Date(Date.now()+3600000*5).toISOString(), home_team:"Philadelphia Eagles", away_team:"Los Angeles Rams", bookmakers:[{markets:[
      {key:"spreads",outcomes:[{name:"Philadelphia Eagles",price:-110,point:-6.5},{name:"Los Angeles Rams",price:-110,point:6.5}]},
      {key:"totals",outcomes:[{name:"Over",price:-110,point:44.5},{name:"Under",price:-110,point:44.5}]},
      {key:"h2h",outcomes:[{name:"Philadelphia Eagles",price:-255},{name:"Los Angeles Rams",price:212}]}
    ]}]},
    { id:"nfl_003", sport:"NFL", commence_time: new Date(Date.now()+3600000*8).toISOString(), home_team:"Detroit Lions", away_team:"Washington Commanders", bookmakers:[{markets:[
      {key:"spreads",outcomes:[{name:"Detroit Lions",price:-110,point:-3},{name:"Washington Commanders",price:-110,point:3}]},
      {key:"totals",outcomes:[{name:"Over",price:-115,point:51},{name:"Under",price:-105,point:51}]},
      {key:"h2h",outcomes:[{name:"Detroit Lions",price:-162},{name:"Washington Commanders",price:136}]}
    ]}]},
  ],
  basketball_nba: [
    { id:"nba_001", sport:"NBA", commence_time: new Date(Date.now()+3600000*1).toISOString(), home_team:"Boston Celtics", away_team:"Miami Heat", bookmakers:[{markets:[
      {key:"spreads",outcomes:[{name:"Boston Celtics",price:-110,point:-8.5},{name:"Miami Heat",price:-110,point:8.5}]},
      {key:"totals",outcomes:[{name:"Over",price:-110,point:218.5},{name:"Under",price:-110,point:218.5}]},
      {key:"h2h",outcomes:[{name:"Boston Celtics",price:-380},{name:"Miami Heat",price:300}]}
    ]}]},
    { id:"nba_002", sport:"NBA", commence_time: new Date(Date.now()+3600000*3).toISOString(), home_team:"Denver Nuggets", away_team:"LA Lakers", bookmakers:[{markets:[
      {key:"spreads",outcomes:[{name:"Denver Nuggets",price:-110,point:-5},{name:"LA Lakers",price:-110,point:5}]},
      {key:"totals",outcomes:[{name:"Over",price:-112,point:224},{name:"Under",price:-108,point:224}]},
      {key:"h2h",outcomes:[{name:"Denver Nuggets",price:-210},{name:"LA Lakers",price:175}]}
    ]}]},
  ],
  baseball_mlb: [
    { id:"mlb_001", sport:"MLB", commence_time: new Date(Date.now()+3600000*6).toISOString(), home_team:"New York Yankees", away_team:"Boston Red Sox", bookmakers:[{markets:[
      {key:"spreads",outcomes:[{name:"New York Yankees",price:-110,point:-1.5},{name:"Boston Red Sox",price:-110,point:1.5}]},
      {key:"totals",outcomes:[{name:"Over",price:-110,point:8.5},{name:"Under",price:-110,point:8.5}]},
      {key:"h2h",outcomes:[{name:"New York Yankees",price:-145},{name:"Boston Red Sox",price:123}]}
    ]}]},
  ],
  icehockey_nhl: [
    { id:"nhl_001", sport:"NHL", commence_time: new Date(Date.now()+3600000*7).toISOString(), home_team:"Colorado Avalanche", away_team:"Vegas Golden Knights", bookmakers:[{markets:[
      {key:"spreads",outcomes:[{name:"Colorado Avalanche",price:-110,point:-1.5},{name:"Vegas Golden Knights",price:-110,point:1.5}]},
      {key:"totals",outcomes:[{name:"Over",price:-115,point:6},{name:"Under",price:-105,point:6}]},
      {key:"h2h",outcomes:[{name:"Colorado Avalanche",price:-128},{name:"Vegas Golden Knights",price:107}]}
    ]}]},
  ],
};

// ─── HELPERS ──────────────────────────────────────────────────────────────────
const fmt = (price) => price > 0 ? `+${price}` : `${price}`;
const a2d = (a) => a > 0 ? a/100+1 : 100/Math.abs(a)+1;
const parlayDec = (legs) => legs.reduce((acc,l) => acc*a2d(l.price),1);
const d2a = (d) => d>=2 ? Math.round((d-1)*100) : Math.round(-100/(d-1));
const calcPayout = (w,p) => Math.round(w*a2d(p)-w);
const fmtNum = (n) => Number(n).toLocaleString();
const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString("en-US",{month:"short",day:"numeric",hour:"numeric",minute:"2-digit"}) : "";
const isLive = (iso) => { const d=new Date(iso),now=new Date(); return now>d && now-d<3600000*4; };
const getMarket = (game,key) => game.bookmakers[0]?.markets.find(m=>m.key===key);
const formatTime = (iso) => {
  const d=new Date(iso),now=new Date(),diff=d-now;
  if(diff<0) return "Live";
  if(diff<3600000*3){ const h=Math.floor(diff/3600000),m=Math.floor((diff%3600000)/60000); return h===0?`${m}m`:`${h}h ${m}m`; }
  return d.toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric",hour:"numeric",minute:"2-digit"});
};

// ─── BET TYPE INFO ────────────────────────────────────────────────────────────
const BET_INFO = {
  spreads:{title:"Point Spread",color:"#4d9fff",icon:"⟺",short:"Bet a team to win by more (or lose by less) than the spread.",how:[{label:"Favorite",desc:"Takes the minus. Must win by MORE than the spread."},{label:"Underdog",desc:"Takes the plus. Can lose by less than spread and still win."},{label:"Push",desc:"Margin equals spread exactly — wager returned."},{label:"Juice",desc:"−110 standard. Risk 110 to win 100."}],example:"Chiefs −3.5: Must win by 4+ to cash."},
  h2h:{title:"Moneyline",color:"#3d9e7a",icon:"✓",short:"Pick who wins outright. No spread.",how:[{label:"Favorite",desc:"Negative odds. Risk more to win less."},{label:"Underdog",desc:"Positive odds. Risk less to win more."},{label:"Simple",desc:"Just pick the winner, any margin counts."}],example:"Bills +148: Bet 100 → win 148 if Bills win outright."},
  totals:{title:"Over / Under",color:"#f5b731",icon:"≈",short:"Bet combined score over or under the posted total.",how:[{label:"Over",desc:"Both teams combine for more than the total."},{label:"Under",desc:"Combined score stays below the total."},{label:"Push",desc:"Exact total — wager returned."}],example:"O/U 47.5: Chiefs 28 Bills 21 = 49 → Over wins."},
  parlay:{title:"Parlay",color:"#ff4d6d",icon:"⚡",short:"Chain multiple bets. All must win. Massive payout.",how:[{label:"Multiplies",desc:"Decimal odds multiply across all legs."},{label:"All or nothing",desc:"One loss kills the whole parlay."},{label:"Push",desc:"Pushed leg removed, parlay continues."},{label:"Example",desc:"Two −110 legs pays roughly +260."}],example:"Chiefs −3.5 + Eagles −6.5: Both must cover. Pays ~+260."},
  teaser:{title:"Teaser",color:"#1d4ed8",icon:"🎯",short:"Move the line in your favor. NFL/CFB spreads & totals only.",how:[{label:"Adjust lines",desc:"Get 6, 6.5, or 7 points added to your spread or total."},{label:"Fixed odds",desc:"2-team 6pt teaser pays +100. More legs = bigger payout."},{label:"All must win",desc:"Like a parlay — every leg must cover the adjusted line."},{label:"NFL/CFB only",desc:"Teasers are only available on football spreads and totals."}],example:"Chiefs −7 becomes −1 with 6pt teaser. Over 47.5 becomes Over 41.5."},
};

// ─── COMPONENTS ───────────────────────────────────────────────────────────────
function LiveBadge() {
  return <span style={{display:"inline-flex",alignItems:"center",gap:4,background:"rgba(255,77,109,0.1)",color:"#ff4d6d",fontSize:10,fontWeight:700,padding:"2px 7px",borderRadius:4,letterSpacing:"0.08em",fontFamily:"'Barlow Condensed',sans-serif"}}><span style={{width:5,height:5,borderRadius:"50%",background:"#ff4d6d",animation:"pulse 1.2s infinite"}}/> LIVE</span>;
}

function NavTab({label,active,onClick,badge}) {
  return <button onClick={onClick} style={{display:"flex",alignItems:"center",gap:6,padding:"10px 16px",border:"none",cursor:"pointer",background:"transparent",color:active?"#f0f4ff":"#6b7280",borderBottom:active?"2px solid #3d9e7a":"2px solid transparent",fontFamily:"'Inter',sans-serif",fontSize:13,fontWeight:active?600:400,transition:"all 0.15s",whiteSpace:"nowrap"}}>
    {label}
    {badge>0&&<span style={{background:"#3d9e7a",color:"#000",fontSize:10,fontWeight:800,width:17,height:17,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center"}}>{badge}</span>}
  </button>;
}

function OddsBtn({label,sublabel,selected,onClick,color="#3d9e7a"}) {
  const bgMap = {"#4d9fff":"#eff6ff","#f5b731":"#fffbeb","#3d9e7a":"#f0fdf8"};
  const selBgMap = {"#4d9fff":"#bfdbfe","#f5b731":"#fde68a","#3d9e7a":"#a7f3d0"};
  const selBorderMap = {"#4d9fff":"#3b82f6","#f5b731":"#f59e0b","#3d9e7a":"#34d399"};
  const bg = selected ? selBgMap[color]||"#d1fae5" : bgMap[color]||"#f9fafb";
  const borderColor = selected ? (selBorderMap[color]||color) : `${color}50`;
  return <button onClick={onClick} style={{display:"flex",flexDirection:"column",alignItems:"center",padding:"6px 4px",minWidth:48,border:`1.5px solid ${borderColor}`,borderRadius:6,cursor:"pointer",backgroundColor:bg,transition:"all 0.12s",width:"100%"}}>
    <span style={{fontSize:10,color:"#1a1a2e",fontWeight:500,fontFamily:"'Inter',sans-serif"}}>{sublabel}</span>
    <span style={{fontSize:12,fontWeight:700,color:"#1a1a2e",fontFamily:"'Inter',sans-serif"}}>{label}</span>
  </button>;
}

function Modal({onClose,children}) {
  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}}>
    <div onClick={e=>e.stopPropagation()} style={{background:"#ffffff",borderRadius:16,padding:28,maxWidth:400,width:"100%",animation:"popIn 0.2s",boxShadow:"0 20px 60px rgba(0,0,0,0.4)"}}>
      {children}
    </div>
  </div>;
}

function BetTypeModal({type,onClose}) {
  const info=BET_INFO[type]; if(!info) return null;
  const bgMap={"#4d9fff":"#eff6ff","#f5b731":"#fffbeb","#3d9e7a":"#f0fdf8","#ff4d6d":"#fff5f5"};
  const borderMap={"#4d9fff":"#bfdbfe","#f5b731":"#fde68a","#3d9e7a":"#a7f3d0","#ff4d6d":"#fecaca"};
  return <Modal onClose={onClose}>
    {/* Header */}
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
      <div style={{width:44,height:44,borderRadius:12,backgroundColor:bgMap[info.color]||"#f9fafb",border:`1.5px solid ${borderMap[info.color]||"#e5e7eb"}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>{info.icon}</div>
      <div style={{flex:1}}>
        <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:22,fontWeight:800,color:"#1a1a2e",marginBottom:2}}>{info.title}</div>
        <div style={{fontSize:13,color:"#374151",fontFamily:"'Inter',sans-serif",lineHeight:1.4}}>{info.short}</div>
      </div>
      <button onClick={onClose} style={{background:"none",border:"none",color:"#9ca3af",fontSize:20,cursor:"pointer",lineHeight:1}}>✕</button>
    </div>
    {/* How it works */}
    <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:16}}>
      {info.how.map((h,i)=><div key={i} style={{display:"flex",gap:12,padding:"10px 14px",backgroundColor:"#f9fafb",border:"1px solid #f3f4f6",borderRadius:8,borderLeft:`3px solid ${info.color}`}}>
        <span style={{color:info.color,fontSize:12,fontWeight:700,minWidth:80,fontFamily:"'Inter',sans-serif"}}>{h.label}</span>
        <span style={{fontSize:13,color:"#374151",lineHeight:1.5,fontFamily:"'Inter',sans-serif"}}>{h.desc}</span>
      </div>)}
    </div>
    {/* Example */}
    <div style={{padding:"12px 14px",backgroundColor:bgMap[info.color]||"#f9fafb",border:`1px solid ${borderMap[info.color]||"#e5e7eb"}`,borderRadius:8}}>
      <div style={{fontSize:11,fontWeight:700,color:info.color,fontFamily:"'Inter',sans-serif",letterSpacing:"0.06em",marginBottom:4}}>EXAMPLE</div>
      <div style={{fontSize:13,color:"#374151",fontFamily:"'Inter',sans-serif",lineHeight:1.5}}>{info.example}</div>
    </div>
  </Modal>;
}

function ConfirmModal({onConfirm,onCancel,title,message,confirmLabel="Confirm",danger=false}) {
  return <Modal onClose={onCancel}>
    <div style={{textAlign:"center",marginBottom:20}}>
      <div style={{fontSize:32,marginBottom:10}}>{danger?"⚠️":"💬"}</div>
      <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:22,fontWeight:800,color:"#1a1a2e",marginBottom:6}}>{title}</div>
      <div style={{fontSize:14,color:"#374151",lineHeight:1.6,fontFamily:"'Inter',sans-serif"}}>{message}</div>
    </div>
    <div style={{display:"flex",gap:10}}>
      <button onClick={onConfirm} style={{flex:1,padding:12,backgroundColor:danger?"#dc2626":"#3d9e7a",color:"#ffffff",border:"none",borderRadius:8,fontFamily:"'Inter',sans-serif",fontSize:15,fontWeight:600,cursor:"pointer"}}>{confirmLabel}</button>
      <button onClick={onCancel} style={{flex:1,padding:12,backgroundColor:"transparent",color:"#6b7280",border:"1px solid #e5e7eb",borderRadius:8,cursor:"pointer",fontSize:14,fontFamily:"'Inter',sans-serif"}}>Cancel</button>
    </div>
  </Modal>;
}

function GameCard({game,slip,onAddBet}) {
  const spread=getMarket(game,"spreads"),total=getMarket(game,"totals"),ml=getMarket(game,"h2h");
  const live=isLive(game.commence_time);
  const isSel=(gid,mkt,name)=>slip.some(b=>b.gameId===gid&&b.market===mkt&&b.selection===name);
  const handle=(market,outcome,marketLabel,icon)=>{
    if(isSel(game.id,market,outcome.name)) onAddBet(null,game.id,market);
    else onAddBet({gameId:game.id,market,marketLabel,icon,selection:outcome.name,price:outcome.price,point:outcome.point,gameName:`${game.away_team} @ ${game.home_team}`,sport:game.sport,commenceTime:game.commence_time},game.id,market);
  };
  return <div style={{backgroundColor:"#ffffff",borderRadius:12,marginBottom:10,overflow:"hidden",animation:"fadeIn 0.3s",boxShadow:"0 1px 4px rgba(0,0,0,0.12)"}}>
    {/* Game header */}
    <div style={{padding:"8px 14px",backgroundColor:"#f8fafc",borderBottom:"1px solid #e5e7eb",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        {live?<LiveBadge/>:<span style={{fontSize:11,color:"#6b7280",fontFamily:"'Inter',sans-serif"}}>{formatTime(game.commence_time)}</span>}
        <span style={{fontSize:11,color:"#9ca3af"}}>·</span>
        <span style={{fontSize:11,color:"#9ca3af",fontFamily:"'Inter',sans-serif",fontWeight:500}}>{game.sport}</span>
      </div>
      <span style={{fontSize:10,color:"#9ca3af",fontFamily:"'Inter',sans-serif"}}>DraftKings</span>
    </div>
    {/* Column headers */}
    <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 90px 90px 56px":"1fr 120px 120px 64px",padding:"6px 10px 2px"}}>
      <div/>
      {["SPREAD","TOTAL","ML"].map(h=><div key={h} style={{textAlign:"center",fontSize:10,color:"#9ca3af",letterSpacing:"0.08em",fontFamily:"'Inter',sans-serif",fontWeight:600}}>{h}</div>)}
    </div>
    {/* Teams */}
    {[game.away_team,game.home_team].map((team,idx)=>{
      const spd=spread?.outcomes.find(o=>o.name===team),tot=total?.outcomes[idx],mlo=ml?.outcomes.find(o=>o.name===team);
      return <div key={team} style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 90px 90px 56px":"1fr 120px 120px 64px",gap:window.innerWidth<768?4:6,padding:window.innerWidth<768?"8px 10px":"8px 14px",alignItems:"center",borderTop:idx===0?"none":"1px solid #f3f4f6"}}>
        <div>
          <div style={{fontSize:window.innerWidth<768?12:14,fontWeight:600,color:"#1a1a2e",fontFamily:"'Inter',sans-serif",lineHeight:1.2}}>{team}</div>
          <div style={{fontSize:10,color:"#9ca3af",fontFamily:"'Inter',sans-serif"}}>{idx===0?"Away":"Home"}</div>
        </div>
        <div style={{display:"flex",justifyContent:"center"}}>
          {spd&&<OddsBtn sublabel={spd.point>0?`+${spd.point}`:`${spd.point}`} label={fmt(spd.price)} selected={isSel(game.id,"spreads",team)} onClick={()=>handle("spreads",{name:team,price:spd.price,point:spd.point},"Spread","⟺")} color="#4d9fff"/>}
        </div>
        <div style={{display:"flex",justifyContent:"center"}}>
          {tot&&<OddsBtn sublabel={`${tot.name} ${tot.point}`} label={fmt(tot.price)} selected={isSel(game.id,"totals",tot.name)} onClick={()=>handle("totals",{name:tot.name,price:tot.price,point:tot.point},"Total","≈")} color="#f5b731"/>}
        </div>
        <div style={{display:"flex",justifyContent:"center"}}>
          {mlo&&<OddsBtn sublabel="" label={fmt(mlo.price)} selected={isSel(game.id,"h2h",team)} onClick={()=>handle("h2h",{name:team,price:mlo.price},"Moneyline","✓")} color="#3d9e7a"/>}
        </div>
      </div>;
    })}
  </div>;
}

function BetSlip({slip,onRemove,credits,teamId,leagueId,onBetPlaced,activeSport}) {
  const [wager,setWager]=useState(100);
  const [wagerInput,setWagerInput]=useState("100");
  const [placed,setPlaced]=useState(false);
  const [placing,setPlacing]=useState(false);
  const [confirmOpen,setConfirmOpen]=useState(false);
  const [betMode,setBetMode]=useState("auto"); // auto, teaser
  const [teaserPts,setTeaserPts]=useState(6);

  const isFootball = activeSport && (activeSport.includes("nfl") || activeSport.includes("ncaaf") || activeSport.includes("college"));
  const teaserEligibleLegs = slip.filter(b=>b.market==="spreads"||b.market==="totals");
  const canTeaser = isFootball && teaserEligibleLegs.length >= 2 && slip.length >= 2 && slip.length <= 6 && slip.every(b=>b.market==="spreads"||b.market==="totals");
  const isTeaser = betMode==="teaser" && canTeaser;
  const isParlay = !isTeaser && slip.length>1;

  // Teaser odds chart - keyed by [legs][points]
  const TEASER_ODDS = {
    2: {6: 100,  6.5: -110, 7: -120},
    3: {6: 180,  6.5:  160, 7:  140},
    4: {6: 300,  6.5:  260, 7:  240},
    5: {6: 450,  6.5:  400, 7:  350},
    6: {6: 700,  6.5:  600, 7:  500},
  };
  const teaserLegs = Math.min(slip.length, 6);
  const teaserOdds = (TEASER_ODDS[teaserLegs] || TEASER_ODDS[6])[teaserPts] || 100;
  const teaserDec = (o) => o < 0 ? 1 + (100/Math.abs(o)) : 1 + (o/100);
  const teaserTotalDec = teaserDec(teaserOdds);
  const baseTeaserOdds = teaserOdds;

  // Adjust line for teaser
  const adjustLine = (bet, pts) => {
    if (bet.market==="spreads") {
      // Move spread in bettor's favor. The point is already signed relative
      // to the selected team (negative = favorite, positive = underdog), so
      // adding points always helps regardless of favorite/underdog or home/away:
      // -7 + 6 = -1 (favorite needs to win by less), +3 + 6 = +9 (dog can lose by more).
      const newPt = bet.point !== null && bet.point !== undefined
        ? parseFloat(bet.point) + pts
        : 0;
      return newPt;
    }
    if (bet.market==="totals") {
      // Over: lower the total; Under: raise the total
      const base = parseFloat(bet.point) || 0;
      return bet.selection.toLowerCase().includes("over") ? base - pts : base + pts;
    }
    return bet.point;
  };

  const parlayOdds=isParlay?d2a(parlayDec(slip)):0;
  const payout=isTeaser
    ? Math.round(wager*teaserTotalDec-wager)
    : isParlay
      ? Math.round(wager*parlayDec(slip)-wager)
      : slip.length===1?calcPayout(wager,slip[0].price):0;

  const doPlace=async()=>{
    setConfirmOpen(false);
    setPlacing(true);
    try {
      let body;
      if (isTeaser) {
        const teaserLegs = slip.map(b => ({
          ...b,
          originalPoint: b.point,
          point: adjustLine(b, teaserPts),
          teaserPoints: teaserPts,
        }));
        body = {
          team_id:teamId, league_id:leagueId,
          game_id: slip.map(b=>b.gameId).join("_"),
          game_name: `${slip.length}-Leg Teaser`,
          sport: slip[0].sport,
          market: "teaser", market_label: "Teaser",
          selection: teaserLegs.map(b=>`${b.selection} ${b.point>0?"+":""}${b.point}`).join(" + "),
          price: teaserOdds, wager, is_parlay: true,
          parlay_legs: teaserLegs,
          teaser_points: teaserPts,
          commence_time: slip.map(b=>b.commenceTime).filter(Boolean).sort()[0],
        };
      } else if(isParlay) {
        body={team_id:teamId,league_id:leagueId,game_id:slip.map(b=>b.gameId).join("_"),game_name:`${slip.length}-leg parlay`,sport:slip[0].sport,market:"parlay",market_label:"Parlay",selection:slip.map(b=>b.selection).join(" + "),price:parlayOdds,wager,is_parlay:true,parlay_legs:slip,commence_time:slip.map(b=>b.commenceTime).filter(Boolean).sort()[0]};
      } else {
        body={team_id:teamId,league_id:leagueId,game_id:slip[0].gameId,game_name:slip[0].gameName,sport:slip[0].sport,market:slip[0].market,market_label:slip[0].marketLabel,selection:slip[0].selection,price:slip[0].price,point:slip[0].point,wager,is_parlay:false,commence_time:slip[0].commenceTime};
      }
      const res=await fetch(`${API}/bet/place`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)});
      const data=await res.json();
      if(!res.ok) throw new Error(data.detail);
      setPlaced(true);
      onBetPlaced();
      setTimeout(()=>setPlaced(false),4000);
    } catch(err){ alert("Error: "+err.message); }
    setPlacing(false);
  };

  if(slip.length===0) return <div style={{padding:24,textAlign:"center",backgroundColor:"#ffffff",height:"100%",width:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
    <div style={{fontSize:32,marginBottom:12,opacity:0.3}}>🎟</div>
    <div style={{fontFamily:"'Inter',sans-serif",fontSize:14,color:"#9ca3af",fontWeight:500}}>Select odds to build your bet</div>
    <div style={{fontSize:12,color:"#9ca3af",marginTop:6,lineHeight:1.6}}>Add 1 for a single.<br/>Add 2+ for a parlay or teaser.</div>
  </div>;

  return <div style={{animation:"slideIn 0.2s",display:"flex",flexDirection:"column",height:"100%",width:"100%",backgroundColor:"#ffffff",overflow:"hidden"}}>
    {confirmOpen&&<Modal onClose={()=>setConfirmOpen(false)}>
      <div style={{textAlign:"center",marginBottom:20}}>
        <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:26,fontWeight:800,color:"#1a1a2e",marginBottom:6}}>CONFIRM BET</div>
        <div style={{display:"inline-block",fontSize:12,fontWeight:600,padding:"3px 12px",borderRadius:20,backgroundColor:isTeaser?"#f0f4ff":isParlay?"#fff7ed":"#f0fdf8",color:isTeaser?"#1d4ed8":isParlay?"#92400e":"#065f46",border:isTeaser?"1px solid #93c5fd":isParlay?"1px solid #fcd34d":"1px solid #a7f3d0",fontFamily:"'Inter',sans-serif"}}>
          {isTeaser?`🎯 ${slip.length}-Leg Teaser (+${teaserPts} pts)`:isParlay?`⚡ ${slip.length}-Leg Parlay`:"Single Bet"}
        </div>
      </div>
      <div style={{backgroundColor:"#f9fafb",borderRadius:10,padding:"14px 16px",marginBottom:12,border:"1px solid #e5e7eb"}}>
        {slip.map((b,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",marginBottom:i<slip.length-1?8:0}}>
          <span style={{fontSize:14,color:"#1a1a2e",fontFamily:"'Inter',sans-serif",fontWeight:500}}>
            {b.selection}{isTeaser
              ? ` ${adjustLine(b,teaserPts)>0?"+":""}${adjustLine(b,teaserPts)} (was ${b.point>0?"+":""}${b.point})`
              : b.point?` ${b.point>0?"+":""}${b.point}`:""}
          </span>
          <span style={{fontSize:13,color:isTeaser?"#1d4ed8":"#6b7280",fontFamily:"'Inter',sans-serif"}}>{isTeaser?`${fmt(baseTeaserOdds)}`:fmt(b.price)}</span>
        </div>)}
      </div>
      <div style={{backgroundColor:"#ffffff",borderRadius:10,padding:"14px 16px",marginBottom:20,border:"1px solid #e5e7eb"}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
          <span style={{fontSize:13,color:"#6b7280",fontFamily:"'Inter',sans-serif"}}>Wager</span>
          <span style={{fontSize:14,fontWeight:600,color:"#1a1a2e",fontFamily:"'Inter',sans-serif"}}>{fmtNum(wager)}</span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",paddingTop:10,borderTop:"1px solid #e5e7eb"}}>
          <span style={{fontSize:14,fontWeight:700,color:"#1a1a2e",fontFamily:"'Inter',sans-serif"}}>To win</span>
          <span style={{fontSize:22,fontWeight:800,color:"#3d9e7a",fontFamily:"'Barlow Condensed',sans-serif"}}>+{fmtNum(payout)}</span>
        </div>
      </div>
      <div style={{display:"flex",gap:10}}>
        <button onClick={doPlace} style={{flex:1,padding:13,backgroundColor:"#3d9e7a",color:"#ffffff",border:"none",borderRadius:8,fontFamily:"'Inter',sans-serif",fontSize:15,fontWeight:600,cursor:"pointer"}}>Confirm Bet</button>
        <button onClick={()=>setConfirmOpen(false)} style={{flex:1,padding:13,backgroundColor:"transparent",color:"#6b7280",border:"1px solid #e5e7eb",borderRadius:8,cursor:"pointer",fontSize:14,fontFamily:"'Inter',sans-serif"}}>Cancel</button>
      </div>
    </Modal>}

    {/* Mode selector - show when 2+ legs */}
    {slip.length >= 2 && (
      <div style={{margin:"12px 20px 0",display:"flex",gap:6}}>
        <button onClick={()=>setBetMode("auto")} style={{flex:1,padding:"7px 0",fontSize:12,fontWeight:700,fontFamily:"'Inter',sans-serif",border:"none",borderRadius:6,cursor:"pointer",background:!isTeaser?"#1a2235":"#f3f4f6",color:!isTeaser?"#ffffff":"#6b7280"}}>
          {slip.length===2?"Single / Parlay":"Parlay"}
        </button>
        {canTeaser && <button onClick={()=>setBetMode("teaser")} style={{flex:1,padding:"7px 0",fontSize:12,fontWeight:700,fontFamily:"'Inter',sans-serif",border:"none",borderRadius:6,cursor:"pointer",background:isTeaser?"#1d4ed8":"#f3f4f6",color:isTeaser?"#ffffff":"#6b7280"}}>
          🎯 Teaser
        </button>}
      </div>
    )}

    {/* Teaser point selector */}
    {isTeaser && (
      <div style={{margin:"8px 20px 0",display:"flex",gap:6}}>
        {[6, 6.5, 7].map(pts=>(
          <button key={pts} onClick={()=>setTeaserPts(pts)} style={{flex:1,padding:"6px 0",fontSize:12,fontWeight:700,fontFamily:"'Inter',sans-serif",border:`1.5px solid ${teaserPts===pts?"#1d4ed8":"#e5e7eb"}`,borderRadius:6,cursor:"pointer",background:teaserPts===pts?"#eff6ff":"#ffffff",color:teaserPts===pts?"#1d4ed8":"#6b7280"}}>
            +{pts} pts
          </button>
        ))}
      </div>
    )}

    <div style={{margin:"8px 20px 4px",padding:"10px 14px",backgroundColor:isTeaser?"#eff6ff":isParlay?"#fff7ed":"#f0fdf8",border:isTeaser?"1px solid #93c5fd":isParlay?"1px solid #fcd34d":"1px solid #a7f3d0",borderRadius:8,display:"flex",alignItems:"center",gap:10}}>
      <span style={{fontFamily:"'Inter',sans-serif",fontSize:13,fontWeight:600,color:isTeaser?"#1d4ed8":isParlay?"#92400e":"#065f46"}}>
        {isTeaser?`🎯 ${slip.length}-Leg Teaser (+${teaserPts} pts)`:isParlay?`⚡ ${slip.length}-Leg Parlay`:"Single Bet"}
      </span>
      {isTeaser&&<span style={{fontFamily:"'Inter',sans-serif",fontSize:14,fontWeight:700,color:"#1d4ed8"}}>{fmt(teaserOdds)}</span>}
      {isParlay&&<span style={{fontFamily:"'Inter',sans-serif",fontSize:14,fontWeight:700,color:"#ff4d6d"}}>{fmt(parlayOdds)}</span>}
    </div>

    {/* Bet items */}
    <div style={{padding:"12px 20px",display:"flex",flexDirection:"column",gap:10,overflowY:"auto",flex:1,minHeight:0}}>
      {slip.map(bet=>{
        const adjPt = isTeaser ? adjustLine(bet, teaserPts) : bet.point;
        return <div key={`${bet.gameId}-${bet.market}`} style={{backgroundColor:"#1a2235",borderRadius:10,padding:"12px 14px",position:"relative",borderLeft:`4px solid ${isTeaser?"#1d4ed8":bet.market==="spreads"?"#4d9fff":bet.market==="totals"?"#f5b731":"#3d9e7a"}`,animation:"fadeIn 0.2s"}}>
          <button onClick={()=>onRemove(bet.gameId,bet.market)} style={{position:"absolute",top:8,right:8,background:"none",border:"none",color:"rgba(255,255,255,0.3)",cursor:"pointer",fontSize:14}}>✕</button>
          <div style={{fontSize:15,fontWeight:700,color:"#ffffff",paddingRight:20,fontFamily:"'Inter',sans-serif",marginBottom:4}}>
            {bet.selection}{adjPt!==null&&adjPt!==undefined?` ${adjPt>0?`+${adjPt}`:adjPt}`:""}
            {isTeaser&&bet.point!==null&&bet.point!==undefined&&<span style={{fontSize:11,color:"rgba(255,255,255,0.4)",marginLeft:6}}>(was {bet.point>0?`+${bet.point}`:bet.point})</span>}
          </div>
          <div style={{fontSize:11,color:"rgba(255,255,255,0.45)",marginBottom:6,fontFamily:"'Inter',sans-serif"}}>{bet.gameName}</div>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:isTeaser?"rgba(29,78,216,0.2)":bet.market==="spreads"?"rgba(77,159,255,0.15)":bet.market==="totals"?"rgba(245,183,49,0.15)":"rgba(61,158,122,0.15)",color:isTeaser?"#93c5fd":bet.market==="spreads"?"#4d9fff":bet.market==="totals"?"#f5b731":"#3d9e7a",fontFamily:"'Inter',sans-serif",fontWeight:600}}>{bet.icon} {isTeaser?"Teaser":bet.marketLabel}</span>
            <span style={{fontSize:12,color:"rgba(255,255,255,0.6)",fontFamily:"'Inter',sans-serif"}}>{isTeaser?fmt(baseTeaserOdds):fmt(bet.price)}</span>
          </div>
        </div>;
      })}
    </div>

    {/* Wager + payout */}
    <div style={{padding:"16px 20px 20px",borderTop:"1px solid #e5e7eb",backgroundColor:"#f9fafb"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
        <div style={{fontSize:11,fontWeight:700,color:"#374151",letterSpacing:"0.08em",fontFamily:"'Inter',sans-serif"}}>WAGER</div>
        <div style={{fontSize:11,color:"#9ca3af",fontFamily:"'Inter',sans-serif"}}>/ {fmtNum(credits)} cr</div>
      </div>
      <input type="number" value={wagerInput} min={1} max={credits} onChange={e=>{ setWagerInput(e.target.value); const v=Number(e.target.value); if(v>=1) setWager(Math.min(v,credits)); }} onBlur={()=>{ if(!wagerInput||Number(wagerInput)<1){ setWagerInput("1"); setWager(1); } }} style={{width:"100%",padding:"10px 14px",backgroundColor:"#ffffff",border:"1.5px solid #3d9e7a",borderRadius:8,color:"#1a1a2e",fontSize:18,fontFamily:"'Inter',sans-serif",fontWeight:700,outline:"none",boxSizing:"border-box",marginBottom:10,textAlign:"center"}}/>
      <div style={{display:"flex",gap:6,marginBottom:14}}>
        {[50,100,250,500].map(v=><button key={v} onClick={()=>{ setWager(Math.min(v,credits)); setWagerInput(String(Math.min(v,credits))); }} style={{flex:1,padding:"7px 0",backgroundColor:wager===Math.min(v,credits)?"#3d9e7a":"#ffffff",border:wager===Math.min(v,credits)?"1.5px solid #3d9e7a":"1px solid #e5e7eb",borderRadius:6,color:wager===v?"#ffffff":"#374151",cursor:"pointer",fontSize:12,fontFamily:"'Inter',sans-serif",fontWeight:600}}>{v}</button>)}
      </div>

      <div style={{backgroundColor:"#ffffff",borderRadius:8,padding:"12px 14px",border:"1px solid #e5e7eb",marginBottom:14}}>
        {isTeaser&&<div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
          <span style={{fontSize:12,color:"#6b7280",fontFamily:"'Inter',sans-serif"}}>Teaser odds</span>
          <span style={{fontSize:13,fontWeight:700,color:"#1d4ed8",fontFamily:"'Inter',sans-serif"}}>{fmt(teaserOdds)}</span>
        </div>}
        {isParlay&&<div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
          <span style={{fontSize:12,color:"#6b7280",fontFamily:"'Inter',sans-serif"}}>Parlay odds</span>
          <span style={{fontSize:13,fontWeight:700,color:"#ff4d6d",fontFamily:"'Inter',sans-serif"}}>{fmt(parlayOdds)}</span>
        </div>}
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
          <span style={{fontSize:12,color:"#6b7280",fontFamily:"'Inter',sans-serif"}}>Wager</span>
          <span style={{fontSize:13,color:"#374151",fontFamily:"'Inter',sans-serif",fontWeight:500}}>{fmtNum(wager)}</span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",paddingTop:8,borderTop:"1px solid #e5e7eb"}}>
          <span style={{fontSize:14,fontWeight:700,color:"#111827",fontFamily:"'Inter',sans-serif"}}>To win</span>
          <span style={{fontSize:20,fontWeight:800,color:"#3d9e7a",fontFamily:"'Barlow Condensed',sans-serif"}}>+{fmtNum(payout)}</span>
        </div>
      </div>

      {placed?(
        <div style={{padding:"14px",backgroundColor:"#f0fdf8",border:"1px solid #a7f3d0",borderRadius:8,textAlign:"center",color:"#3d9e7a",fontFamily:"'Inter',sans-serif",fontSize:14,fontWeight:600,animation:"popIn 0.3s"}}>
          ✓ Bet placed — check My Bets tab
        </div>
      ):(
        <button onClick={()=>setConfirmOpen(true)} disabled={placing||wager>credits} style={{width:"100%",padding:"13px",border:"none",backgroundColor:wager>credits?"#e5e7eb":"#3d9e7a",color:wager>credits?"#9ca3af":"#ffffff",borderRadius:8,cursor:wager>credits?"not-allowed":"pointer",fontFamily:"'Inter',sans-serif",fontSize:15,fontWeight:600}}>
          {placing?"Placing...":`Place ${isTeaser?"Teaser":isParlay?"Parlay":"Bet"} · ${fmtNum(wager)}`}
        </button>
      )}
    </div>
  </div>;
}

function LeaderboardView({leagueId,teamId}) {
  const [board,setBoard]=useState([]);
  const [boardBets,setBoardBets]=useState([]);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState(null);
  const [expanded,setExpanded]=useState(null);
  const [panelTab,setPanelTab]=useState("live");
  const mob = window.innerWidth < 768;
  const mktIcon=(m)=>m==="spreads"?"⟺":m==="totals"?"≈":"✓";
  const mktColor=(m)=>m==="spreads"?"#2563eb":m==="totals"?"#b45309":"#15803d";
  const mktDim=(m)=>m==="spreads"?"rgba(77,159,255,0.12)":m==="totals"?"rgba(245,183,49,0.18)":"rgba(61,158,122,0.14)";

  const toggleTeam=(id)=>{
    setExpanded(prev=>{
      if(prev===id) return null;
      setPanelTab("live");
      return id;
    });
  };

  useEffect(()=>{
    const load=async()=>{
      setLoading(true); setError(null);
      try {
        const [bRes,lRes]=await Promise.all([
          fetch(`${API}/league/${leagueId}/leaderboard`),
          fetch(`${API}/league/${leagueId}/bets/board`),
        ]);
        setBoard(await bRes.json());
        const lData=await lRes.json();
        if(Array.isArray(lData)) setBoardBets(lData);
      }
      catch(e){ setError("Could not load standings"); }
      setLoading(false);
    };
    load();
  },[leagueId]);

  if(loading) return <div style={{textAlign:"center",padding:60,color:"#6b7280",fontFamily:"'Inter',sans-serif"}}>Loading standings...</div>;
  if(error) return <div style={{textAlign:"center",padding:40,color:"#ff4d6d",fontSize:13}}>{error}</div>;

  return <div style={{padding:mob?"12px":"16px 24px",maxWidth:860,margin:"0 auto"}}>
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20}}>
      <div style={{fontFamily:"'Inter',sans-serif",fontSize:22,fontWeight:800,color:"#f0f4ff"}}>Leaderboard</div>
      <div style={{background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:20,padding:"4px 12px",fontSize:13,fontWeight:600,color:"#f0f4ff",fontFamily:"'Inter',sans-serif"}}>{board.length} teams</div>
    </div>

    {!mob && (
      <div style={{display:"grid",gridTemplateColumns:"56px 1fr 110px 80px",gap:8,padding:"0 16px 10px"}}>
        <div style={{fontSize:11,fontWeight:600,color:"#4b5563",letterSpacing:"0.04em"}}>RANK</div>
        <div style={{fontSize:11,fontWeight:600,color:"#4b5563",letterSpacing:"0.04em"}}>TEAM</div>
        <div style={{fontSize:11,fontWeight:600,color:"#4b5563",textAlign:"right",letterSpacing:"0.04em"}}>CREDITS</div>
        <div style={{fontSize:11,fontWeight:600,color:"#4b5563",textAlign:"right",letterSpacing:"0.04em"}}>+/-</div>
      </div>
    )}

    {board.map((team,i)=>{
      const isMe = team.team_id===teamId;
      const change = team.credit_change;
      const isOpen = expanded===team.team_id;
      const teamBets = boardBets.filter(b=>b.team_id===team.team_id);
      const lockedBets = teamBets.filter(b=>b.board_state==="locked");
      const liveNowBets = teamBets.filter(b=>b.board_state==="live");
      const historyBets = teamBets.filter(b=>b.board_state==="history");

      const canExpand = (lockedBets.length+liveNowBets.length+historyBets.length)>0;

      return (
        <div key={team.team_id} style={{marginBottom:8}}>
        <div onClick={canExpand?()=>toggleTeam(team.team_id):undefined} style={{
          display:"grid",
          gridTemplateColumns:mob?"48px 1fr auto":"56px 1fr 110px 80px",
          gap:8,
          alignItems:"center",
          padding:"13px 16px",
          cursor:canExpand?"pointer":"default",
          backgroundColor:isMe?"#f0fdf8":"#ffffff",
          border:isMe?"1.5px solid #a7f3d0":"1px solid #f3f4f6",
          borderBottom:isOpen?"none":undefined,
          borderRadius:isOpen?"12px 12px 0 0":12,
          boxShadow:"0 1px 3px rgba(0,0,0,0.06)",
        }}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
            <span style={{fontSize:i<3?20:13,fontFamily:"'Inter',sans-serif",fontWeight:600,color:"#9ca3af"}}>
              {i===0?"🥇":i===1?"🥈":i===2?"🥉":`#${i+1}`}
            </span>
          </div>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
              <span style={{fontFamily:"'Inter',sans-serif",fontSize:14,fontWeight:700,color:"#111827"}}>{team.team_name}</span>
              {isMe&&<span style={{fontSize:9,padding:"2px 6px",backgroundColor:"#f0fdf8",color:"#3d9e7a",border:"1px solid #a7f3d0",borderRadius:4,fontFamily:"'Inter',sans-serif",fontWeight:700}}>YOU</span>}
            </div>
            <div style={{fontSize:11,color:"#9ca3af",fontFamily:"'Inter',sans-serif"}}>
              {team.owner_name}
              {team.pending_bets>0 ? (
                <span style={{color:"#f59e0b"}}>
                  {" "}· {team.pending_bets} pending
                  {canExpand && <span style={{marginLeft:4,fontSize:9,display:"inline-block",transform:isOpen?"rotate(180deg)":"none",transition:"transform 0.15s"}}>▼</span>}
                </span>
              ) : historyBets.length>0 && (
                <span style={{color:"#6b7280",cursor:"pointer"}}>
                  <span style={{marginLeft:6,fontSize:9,display:"inline-block",transform:isOpen?"rotate(180deg)":"none",transition:"transform 0.15s"}}>▼</span>
                </span>
              )}
            </div>
          </div>
          {/* Mobile: stack credits + change in one cell */}
          {mob ? (
            <div style={{textAlign:"right"}}>
              <div style={{fontFamily:"'Inter',sans-serif",fontSize:16,fontWeight:800,color:"#111827"}}>{fmtNum(team.credits)}</div>
              <div style={{fontSize:12,fontWeight:700,color:change>0?"#3d9e7a":change<0?"#ef4444":"#9ca3af",fontFamily:"'Inter',sans-serif",marginTop:2}}>
                {change>0?"+":""}{fmtNum(change)}
              </div>
            </div>
          ) : (
            <>
              <div style={{textAlign:"right",fontFamily:"'Inter',sans-serif",fontSize:16,fontWeight:800,color:"#111827"}}>{fmtNum(team.credits)}</div>
              <div style={{textAlign:"right",fontSize:13,fontWeight:700,color:change>0?"#3d9e7a":change<0?"#ef4444":"#9ca3af",fontFamily:"'Inter',sans-serif"}}>
                {change>0?"+":""}{fmtNum(change)}
              </div>
            </>
          )}
        </div>
        {isOpen && (
          <div style={{
            border:isMe?"1.5px solid #a7f3d0":"1px solid #f3f4f6", borderTop:"1px solid #f3f4f6",
            borderRadius:"0 0 12px 12px", background:"#fafafa", padding:"10px 16px 12px 58px",
          }}>
            <div style={{display:"flex",gap:6,marginBottom:10}}>
              <div onClick={()=>setPanelTab("live")} style={{padding:"4px 12px",borderRadius:20,border:"1px solid",borderColor:panelTab==="live"?"#3d9e7a":"#e5e7eb",background:panelTab==="live"?"#f0fdf8":"#ffffff",color:panelTab==="live"?"#3d9e7a":"#6b7280",fontFamily:"'Inter',sans-serif",fontWeight:600,fontSize:11,cursor:"pointer"}}>Live Now</div>
              <div onClick={()=>setPanelTab("history")} style={{padding:"4px 12px",borderRadius:20,border:"1px solid",borderColor:panelTab==="history"?"#3d9e7a":"#e5e7eb",background:panelTab==="history"?"#f0fdf8":"#ffffff",color:panelTab==="history"?"#3d9e7a":"#6b7280",fontFamily:"'Inter',sans-serif",fontWeight:600,fontSize:11,cursor:"pointer"}}>History</div>
            </div>

            {panelTab==="live" && (
              <div style={{maxHeight:220,overflowY:"auto",paddingRight:4}}>
                {(lockedBets.length+liveNowBets.length)===0 ? (
                  <div style={{fontSize:12,color:"#9ca3af",fontFamily:"'Inter',sans-serif",padding:"4px 0"}}>No pending bets</div>
                ) : <>
                  {lockedBets.map(b=>(
                    <div key={b.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,padding:"7px 0",fontSize:12,fontFamily:"'Inter',sans-serif",borderBottom:"1px solid #f0f0f0"}}>
                      <span style={{color:"#9ca3af",fontStyle:"italic",display:"flex",alignItems:"center",gap:7}}><span style={{fontStyle:"normal",fontSize:13}}>🔒</span>Pick locked</span>
                      <span style={{color:"#6b7280",fontWeight:600,flexShrink:0}}>{fmtNum(b.wager)}</span>
                    </div>
                  ))}
                  {liveNowBets.map(b=>{
                    const dot = <span style={{width:6,height:6,borderRadius:"50%",background:"#ef4444",display:"inline-block",marginRight:5,flexShrink:0}}/>;
                    if(b.is_parlay && b.parlay_legs?.length>0){
                      return (
                        <div key={b.id} style={{padding:"7px 0",borderBottom:"1px solid #f0f0f0"}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:12,marginBottom:5}}>
                            <span style={{display:"flex",alignItems:"center",color:"#374151",fontWeight:600}}>{dot}{b.parlay_legs.length}-Leg {b.market_label||"Parlay"}</span>
                            <span style={{color:"#111827",fontWeight:600}}>{fmtNum(b.wager)} → {fmtNum(b.wager+(b.to_win||0))}</span>
                          </div>
                          <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                            {b.parlay_legs.map((l,li)=>(
                              <span key={li} style={{fontSize:10,padding:"2px 7px",borderRadius:5,fontWeight:600,whiteSpace:"nowrap",background:mktDim(l.market),color:mktColor(l.market)}}>
                                {mktIcon(l.market)} {l.selection}{l.point?` ${l.point>0?"+":""}${l.point}`:""}
                              </span>
                            ))}
                          </div>
                        </div>
                      );
                    }
                    return (
                      <div key={b.id} style={{display:"flex",justifyContent:"space-between",gap:10,padding:"7px 0",fontSize:12,fontFamily:"'Inter',sans-serif",borderBottom:"1px solid #f0f0f0"}}>
                        <span style={{color:"#374151",display:"flex",alignItems:"center"}}>{dot}{b.selection}{b.point?` ${b.point>0?"+":""}${b.point}`:""} <span style={{color:"#9ca3af",marginLeft:4}}>· {b.game_name}</span></span>
                        <span style={{color:"#6b7280",fontWeight:600,flexShrink:0}}>{fmtNum(b.wager)}</span>
                      </div>
                    );
                  })}
                </>}
              </div>
            )}

            {panelTab==="history" && (
              <div style={{maxHeight:220,overflowY:"auto",paddingRight:4}}>
                {historyBets.length===0 ? (
                  <div style={{fontSize:12,color:"#9ca3af",fontFamily:"'Inter',sans-serif",padding:"4px 0"}}>No settled bets yet</div>
                ) : historyBets.map(b=>{
                  const won=b.result==="won", lost=b.result==="lost";
                  const resultBadge=(
                    <span style={{fontSize:10,padding:"2px 7px",borderRadius:20,fontWeight:700,marginLeft:6,background:won?"#f0fdf8":lost?"#fff5f5":"#fffbeb",color:won?"#065f46":lost?"#dc2626":"#92400e",border:won?"1px solid #a7f3d0":lost?"1px solid #fecaca":"1px solid #fcd34d"}}>{won?"Won":lost?"Lost":"Push"}</span>
                  );
                  const payout = <span style={{fontWeight:600,flexShrink:0,color:won?"#3d9e7a":lost?"#ff4d6d":"#6b7280"}}>{won?`+${fmtNum(b.to_win)}`:lost?`-${fmtNum(b.wager)}`:"Push"}</span>;

                  if(b.is_parlay && b.parlay_legs?.length>0){
                    const legColor=(r)=>r==="won"?"#15803d":r==="lost"?"#dc2626":"#6b7280";
                    const legBg=(r)=>r==="won"?"rgba(61,158,122,0.14)":r==="lost"?"rgba(220,38,38,0.10)":"rgba(107,114,128,0.10)";
                    return (
                      <div key={b.id} style={{padding:"7px 0",borderBottom:"1px solid #f0f0f0"}}>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:12,marginBottom:5}}>
                          <span style={{color:"#374151",fontWeight:600}}>{b.parlay_legs.length}-Leg {b.market_label||"Parlay"}{resultBadge}</span>
                          {payout}
                        </div>
                        <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                          {b.parlay_legs.map((l,li)=>{
                            const gname = l.gameName||l.game_name;
                            return (
                              <span key={li} style={{fontSize:10,padding:"2px 7px",borderRadius:5,fontWeight:600,whiteSpace:"nowrap",background:legBg(l.result),color:legColor(l.result)}}>
                                {mktIcon(l.market)} {l.selection}{l.point?` ${l.point>0?"+":""}${l.point}`:""}{gname&&<span style={{opacity:0.75}}> · {gname}</span>}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    );
                  }

                  return (
                    <div key={b.id} style={{display:"flex",justifyContent:"space-between",gap:10,padding:"7px 0",fontSize:12,fontFamily:"'Inter',sans-serif",borderBottom:"1px solid #f0f0f0"}}>
                      <span style={{color:"#374151"}}>{b.selection}{b.point?` ${b.point>0?"+":""}${b.point}`:""} <span style={{color:"#9ca3af"}}>· {b.game_name}</span>
                        {resultBadge}
                      </span>
                      {payout}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
        </div>
      );
    })}
  </div>;
}

function MyBetsView({teamId}) {
  const [bets,setBets]=useState([]);
  const [loading,setLoading]=useState(true);

  useEffect(()=>{
    const load=async()=>{
      setLoading(true);
      try { const res=await fetch(`${API}/team/${teamId}/bets`); setBets(await res.json()); }
      catch(e){ console.error(e); }
      setLoading(false);
    };
    load();
  },[teamId]);

  const pending=bets.filter(b=>b.status==="pending");
  const settled=bets.filter(b=>b.status==="settled");
  const mktColor=(m)=>m==="spreads"?"#4d9fff":m==="totals"?"#f5b731":m==="parlay"?"#ff4d6d":"#3d9e7a";
  const mktDim=(m)=>m==="spreads"?"rgba(77,159,255,0.12)":m==="totals"?"rgba(245,183,49,0.12)":m==="parlay"?"rgba(255,77,109,0.12)":"rgba(61,158,122,0.12)";

  if(loading) return <div style={{textAlign:"center",padding:60,color:"#6b7280",fontFamily:"'Inter',sans-serif"}}>Loading bets...</div>;

  const BetCard=({bet})=>{
    const won=bet.result==="won",lost=bet.result==="lost";
    return <div style={{backgroundColor:"#ffffff",border:"1px solid #f3f4f6",borderRadius:12,padding:"14px 16px",marginBottom:10,boxShadow:"0 1px 3px rgba(0,0,0,0.06)",animation:"fadeIn 0.3s"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
        <div style={{flex:1}}>
          <div style={{fontFamily:"'Inter',sans-serif",fontSize:15,fontWeight:700,marginBottom:3,color:"#1a1a2e"}}>{bet.selection}{bet.point?` ${bet.point>0?"+":""}${bet.point}`:""}</div>
          <div style={{fontSize:12,color:"#9ca3af",marginBottom:8,fontFamily:"'Inter',sans-serif"}}>{bet.game_name}</div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
            <span style={{fontSize:11,padding:"2px 8px",borderRadius:6,backgroundColor:mktDim(bet.market),color:mktColor(bet.market),fontFamily:"'Inter',sans-serif",fontWeight:600}}>{bet.market_label}</span>
            <span style={{fontSize:12,color:"#6b7280",fontFamily:"'Inter',sans-serif"}}>{fmt(bet.price)}</span>
            <span style={{fontSize:11,color:"#9ca3af",fontFamily:"'Inter',sans-serif"}}>{fmtDate(bet.placed_at)}</span>
          </div>
          {bet.is_parlay&&bet.parlay_legs?.length>0&&<div style={{marginTop:10,paddingTop:10,borderTop:"1px solid #f3f4f6"}}>
            {bet.parlay_legs.map((leg,i)=>{
              const lr=leg.result;
              const dr=lr||(bet.result==="won"?"won":null);
              const bc=dr==="won"?"#3d9e7a":dr==="lost"?"#dc2626":"#e5e7eb";
              return (
                <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",borderLeft:`3px solid ${bc}`,paddingLeft:8,marginBottom:6,paddingBottom:6,borderBottom:i<bet.parlay_legs.length-1?"1px solid #f9fafb":"none"}}>
                  <div>
                    <div style={{fontSize:12,fontWeight:600,color:"#1a1a2e",fontFamily:"'Inter',sans-serif"}}>{leg.selection}{leg.point?` ${leg.point>0?"+":""}${leg.point}`:""}</div>
                    <div style={{fontSize:11,color:"#9ca3af",fontFamily:"'Inter',sans-serif"}}>{leg.gameName||leg.game_name} · {leg.price>0?"+":""}{leg.price}</div>
                  </div>
                  <span style={{fontSize:16,marginLeft:8,flexShrink:0}}>{dr==="won"?"✓":dr==="lost"?"✗":"⏳"}</span>
                </div>
              );
            })}
          </div>}
        </div>
        <div style={{textAlign:"right",flexShrink:0}}>
          {bet.status==="pending"?(
            <>
              <span style={{fontSize:10,padding:"3px 8px",borderRadius:20,backgroundColor:"#fffbeb",color:"#92400e",border:"1px solid #fcd34d",fontFamily:"'Inter',sans-serif",fontWeight:600}}>Pending</span>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:18,fontWeight:800,marginTop:6,color:"#1a1a2e"}}>{fmtNum(bet.wager)}</div>
              <div style={{fontSize:11,color:"#3d9e7a",fontFamily:"'Inter',sans-serif"}}>to win {fmtNum(bet.to_win)}</div>
            </>
          ):(
            <>
              <span style={{fontSize:10,padding:"3px 8px",borderRadius:20,fontFamily:"'Inter',sans-serif",fontWeight:600,backgroundColor:won?"#f0fdf8":lost?"#fff5f5":"#fffbeb",color:won?"#065f46":lost?"#dc2626":"#92400e",border:won?"1px solid #a7f3d0":lost?"1px solid #fecaca":"1px solid #fcd34d"}}>{won?"Won":lost?"Lost":"Push"}</span>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:18,fontWeight:800,marginTop:6,color:won?"#3d9e7a":lost?"#ff4d6d":"#6b7280"}}>
                {won?`+${fmtNum(bet.to_win)}`:lost?`-${fmtNum(bet.wager)}`:"Push"}
              </div>
              <div style={{fontSize:11,color:"#9ca3af",fontFamily:"'Inter',sans-serif"}}>wagered {fmtNum(bet.wager)}</div>
            </>
          )}
        </div>
      </div>
    </div>;
  };

  return <div style={{padding:"16px 20px",maxWidth:860,margin:"0 auto"}}>
    <div style={{marginBottom:28}}>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14,padding:"12px 16px",backgroundColor:"#fffbeb",border:"1px solid #fcd34d",borderRadius:10}}>
        <div style={{fontFamily:"'Inter',sans-serif",fontSize:16,fontWeight:700,color:"#92400e"}}>⏳ Pending Bets</div>
        <span style={{backgroundColor:"#fcd34d",color:"#92400e",fontSize:12,fontWeight:700,padding:"2px 8px",borderRadius:20,fontFamily:"'Inter',sans-serif"}}>{pending.length}</span>

      </div>
      {pending.length===0?<div style={{padding:"24px 16px",textAlign:"center",backgroundColor:"#ffffff",borderRadius:12,border:"1px solid #f3f4f6",color:"#9ca3af",fontSize:13,fontFamily:"'Inter',sans-serif"}}>No pending bets — place a bet to get started</div>:pending.map(b=><BetCard key={b.id} bet={b}/>)}
    </div>
    <div>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14,padding:"12px 16px",backgroundColor:"#f3f4f6",border:"1px solid #e5e7eb",borderRadius:10}}>
        <div style={{fontFamily:"'Inter',sans-serif",fontSize:16,fontWeight:700,color:"#374151"}}>📋 Bet History</div>
        <span style={{backgroundColor:"#e5e7eb",color:"#374151",fontSize:12,fontWeight:700,padding:"2px 8px",borderRadius:20,fontFamily:"'Inter',sans-serif"}}>{settled.length}</span>
        {settled.length>0&&<div style={{marginLeft:"auto",display:"flex",gap:12,fontSize:12}}>
          <span style={{color:"#3d9e7a"}}>{settled.filter(b=>b.result==="won").length}W</span>
          <span style={{color:"#ff4d6d"}}>{settled.filter(b=>b.result==="lost").length}L</span>
          <span style={{color:"#f5b731"}}>{settled.filter(b=>b.result==="push").length} Push</span>
        </div>}
      </div>
      {settled.length===0?<div style={{padding:"20px 16px",textAlign:"center",background:"#111827",borderRadius:10,border:"1px solid var(--border)",color:"#4b5563",fontSize:13}}>No settled bets yet</div>:settled.map(b=><BetCard key={b.id} bet={b}/>)}
    </div>
  </div>;
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────

function AdminBanner({ leagueId, isMobile }) {
  const key = `scraps_admin_seen_${leagueId}`;
  const [seen, setSeen] = useState(()=>!!localStorage.getItem(key));
  if (seen) return null;
  return (
    <div style={{background:"#1e3a5f",borderBottom:"2px solid #3b82f6",padding:"10px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:12}}>
      <div style={{display:"flex",alignItems:"center",gap:10,flex:1,minWidth:0}}>
        <span style={{fontSize:isMobile?16:18,flexShrink:0}}>⚙️</span>
        <span style={{fontSize:isMobile?12:13,color:"#bfdbfe",fontFamily:"'Inter',sans-serif",lineHeight:1.4}}>
          <strong style={{color:"#ffffff"}}>You're the league admin.</strong>{" "}
          {isMobile ? "Tap Admin in the nav below to manage your league." : "Tap ⚙️ next to the league name to manage settings, members and more."}
        </span>
      </div>
      <button onClick={()=>{localStorage.setItem(key,"1");setSeen(true);}} style={{background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:6,color:"#ffffff",cursor:"pointer",fontSize:12,fontWeight:600,padding:"5px 12px",fontFamily:"'Inter',sans-serif",flexShrink:0,whiteSpace:"nowrap"}}>
        Got it
      </button>
    </div>
  );
}

export default function Sportsbook(props) {
  const {teamId,leagueId,teamName,leagueName,credits:initialCredits,onLeaveLeague,enabledSports,playerProps,emailVerified,isAdmin,onAdminClick}=props;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Build sports list based on what the league has enabled
  const leagueSports = enabledSports?.length > 0
    ? ALL_SPORTS_CONFIG.filter(s => enabledSports.includes(s.key))
    : SPORTS;
  const [activeSport,setActiveSport]=useState(leagueSports[0]?.key || "americanfootball_nfl");
  const [activeView,setActiveView]=useState("book");
  const [games,setGames]=useState([]);
  const [slip,setSlip]=useState([]);
  const [blockedMsg,setBlockedMsg]=useState("");
  const [loading,setLoading]=useState(true);
  const [oddsError,setOddsError]=useState(false);
  const [infoModal,setInfoModal]=useState(null);
  const [credits,setCredits]=useState(initialCredits||5000);
  const [pendingCount,setPendingCount]=useState(0);
  const [leaveConfirm,setLeaveConfirm]=useState(false);
  const [mobileSlipOpen,setMobileSlipOpen]=useState(false);
  const [sportDropdownOpen,setSportDropdownOpen]=useState(false);

  // Load odds via backend
  useEffect(()=>{
    setLoading(true); setOddsError(false);
    const load=async()=>{
      try {
        const res=await fetch(`${API}/odds/${activeSport}`);
        if(!res.ok) throw new Error();
        const data=await res.json();
        if(Array.isArray(data)&&data.length>0){
          setGames(data.map(g=>({...g,sport:ALL_SPORTS_CONFIG.find(s=>s.key===activeSport)?.label||""})));
        } else {
          setGames(MOCK_GAMES[activeSport]||[]);
        }
      } catch {
        setOddsError(true);
        setGames(MOCK_GAMES[activeSport]||[]);
      }
      setLoading(false);
    };
    load();
  },[activeSport]);

  // Refresh credits + pending count
  useEffect(()=>{
    if(!teamId) return;
    const refresh=async()=>{
      try {
        const [tr,br]=await Promise.all([fetch(`${API}/team/${teamId}`),fetch(`${API}/team/${teamId}/bets`)]);
        const td=await tr.json(),bd=await br.json();
        setCredits(td.credits);
        setPendingCount(bd.filter(b=>b.status==="pending").length);
      } catch(e){}
    };
    refresh();
    const t=setInterval(refresh,15000);
    return ()=>clearInterval(t);
  },[teamId]);

  const handleAddBet=useCallback((bet,gameId,market)=>{
    if(!bet){
      setSlip(prev=>prev.filter(b=>!(b.gameId===gameId&&b.market===market)));
      return;
    }
    setSlip(prev=>{
      // Block combining moneyline + spread on the same game. Any other
      // market pairing on the same game (e.g. spread + total) is allowed as
      // separate legs; a second pick of the SAME market on the same game
      // just replaces the existing leg (normal toggle behavior).
      const conflict=prev.find(b=>b.gameId===gameId&&b.market!==bet.market&&
        ((b.market==="spreads"&&bet.market==="h2h")||(b.market==="h2h"&&bet.market==="spreads")));
      if(conflict){
        setBlockedMsg("Can't combine spread and moneyline on the same game");
        return prev;
      }
      return [...prev.filter(b=>!(b.gameId===gameId&&b.market===bet.market)),bet];
    });
  },[]);
  const handleRemove=useCallback((gameId,market)=>setSlip(prev=>prev.filter(b=>!(b.gameId===gameId&&b.market===market))),[]);
  const handleAddBetWithSlip=(bet,gameId,market)=>{ handleAddBet(bet,gameId,market); };
  const handleBetPlaced=useCallback(()=>{
    setSlip([]);
    fetch(`${API}/team/${teamId}`).then(r=>r.json()).then(d=>setCredits(d.credits)).catch(()=>{});
    setActiveView("bets");
  },[teamId]);

  useEffect(()=>{
    if(!blockedMsg) return;
    const t=setTimeout(()=>setBlockedMsg(""),2600);
    return ()=>clearTimeout(t);
  },[blockedMsg]);

  return <>
    <style>{CSS}</style>
    {blockedMsg&&<div style={{position:"fixed",top:16,left:"50%",transform:"translateX(-50%)",zIndex:9999,background:"#1a2235",color:"#fff",padding:"10px 18px",borderRadius:8,fontFamily:"'Inter',sans-serif",fontSize:13,fontWeight:600,boxShadow:"0 4px 16px rgba(0,0,0,0.3)",border:"1px solid rgba(255,255,255,0.1)"}}>{blockedMsg}</div>}
    {infoModal&&<BetTypeModal type={infoModal} onClose={()=>setInfoModal(null)}/>}
    {leaveConfirm&&<ConfirmModal title="Leave League?" message="You'll return to your leagues hub. You can come back anytime." confirmLabel="Leave League" danger={false} onConfirm={onLeaveLeague} onCancel={()=>setLeaveConfirm(false)}/>}

    <div style={{height:"100vh",overflow:"hidden",background:"#0a0e1a",display:"flex",flexDirection:"column"}}>
      {/* Top bar */}
      <div style={{background:"#111827",borderBottom:"1px solid rgba(255,255,255,0.07)",padding:isMobile?"10px 14px":"12px 20px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div style={{display:"flex",alignItems:"center",gap:isMobile?10:16,minWidth:0}}>
          <button onClick={()=>setLeaveConfirm(true)} style={{background:"none",border:"none",color:"#ffffff",cursor:"pointer",fontSize:isMobile?26:13,fontFamily:"'Inter',sans-serif",flexShrink:0,padding:0,lineHeight:1,fontWeight:900}}>
            {isMobile ? "≡" : "≡ My Leagues"}
          </button>
          {!isMobile && <div style={{width:1,height:20,backgroundColor:"rgba(255,255,255,0.1)"}}/>}
          <div style={{display:"flex",alignItems:"center",gap:8,minWidth:0}}>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:isMobile?20:18,fontWeight:800,color:"#f0f4ff",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{leagueName}</div>
            {isAdmin && !isMobile && <button onClick={onAdminClick} style={{background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.15)",borderRadius:6,padding:"3px 8px",cursor:"pointer",fontSize:14,color:"#9ca3af",flexShrink:0}} title="League Admin">⚙️</button>}
          </div>
        </div>
        <div style={{flexShrink:0,display:"flex",alignItems:"center",gap:8}}>
          {!isMobile && <div style={{textAlign:"right"}}><div style={{fontSize:11,color:"#6b7280",fontFamily:"'Inter',sans-serif",marginBottom:1}}>{teamName}</div></div>}
          {oddsError&&!isMobile&&<span style={{fontSize:11,color:"#f5b731"}}>⚠ Sample odds</span>}
          <div style={{backgroundColor:"rgba(61,158,122,0.25)",border:"1.5px solid #3d9e7a",borderRadius:10,padding:isMobile?"6px 12px":"6px 14px",flexShrink:0,boxShadow:"inset 0 1px 0 rgba(255,255,255,0.15)"}}>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:isMobile?18:22,fontWeight:800,color:"#ffffff",lineHeight:1,textAlign:"center",textShadow:"0 1px 2px rgba(0,0,0,0.2)"}}>{fmtNum(credits)}</div>
            {!isMobile&&<div style={{fontSize:10,color:"rgba(255,255,255,0.6)",textAlign:"center",fontFamily:"'Inter',sans-serif",marginTop:1}}>credits</div>}
          </div>
        </div>
      </div>

      {/* Main nav tabs */}
      <div style={{background:"#111827",borderBottom:"1px solid rgba(255,255,255,0.07)",padding:isMobile?"0":"0 24px",display:"flex",gap:0,justifyContent:"center"}}>
        {[
          {key:"book", label:"Sportsbook", icon:"🏈"},
          {key:"leaderboard", label:"Leaderboard", icon:"🏆"},
          {key:"bets", label:"My Bets", icon:"🎟", badge:pendingCount},
          ...(isMobile && isAdmin ? [{key:"admin", label:"Admin", icon:"⚙️"}] : []),
        ].map(tab => (
          <button key={tab.key} onClick={()=>{ if(tab.key==="admin") { onAdminClick(); } else { setActiveView(tab.key); } }} style={{
            flex:isMobile?1:undefined,
            padding:isMobile?"10px 4px":"14px 28px", border:"none", background:"transparent", cursor:"pointer",
            color: activeView===tab.key ? "#f0f4ff" : "#6b7280",
            borderBottom: activeView===tab.key ? "3px solid #3d9e7a" : "3px solid transparent",
            fontFamily:"'Inter',sans-serif", fontSize:isMobile?11:15, fontWeight: activeView===tab.key ? 700 : 400,
            whiteSpace:"nowrap", display:"flex", flexDirection:isMobile?"column":"row", alignItems:"center", gap:isMobile?2:8,
          }}>
            <span style={{fontSize:isMobile?18:16}}>{tab.icon}</span>
            <span style={{display:"flex",alignItems:"center",gap:3,justifyContent:"center"}}>
              {isMobile ? (tab.label === 'My Bets' ? tab.label : tab.label.split(" ")[0]) : tab.label}
              {tab.badge > 0 && <span style={{background:"#3d9e7a",color:"#fff",borderRadius:10,fontSize:9,fontWeight:700,padding:"1px 5px",lineHeight:1.4}}>{tab.badge}</span>}
            </span>
          </button>
        ))}
      </div>

      {isAdmin && <AdminBanner leagueId={leagueId} isMobile={isMobile} />}

      {/* Email verification banner */}
      {!emailVerified && (
        <div style={{background:"#fffbeb",borderBottom:"2px solid #f59e0b",padding:"12px 20px"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12}}>
            <div style={{fontSize:13,color:"#92400e",fontFamily:"'Inter',sans-serif",fontWeight:600}}>
              📧 Please verify your email to place bets
            </div>
            <button onClick={async()=>{
              await fetch(`${API}/auth/resend-verification?email=${encodeURIComponent(props.email)}`,{method:"POST"});
              alert("Verification email sent to " + props.email + "!");
            }} style={{padding:"6px 14px",background:"#f59e0b",border:"none",borderRadius:6,color:"#fff",cursor:"pointer",fontSize:12,fontFamily:"'Inter',sans-serif",fontWeight:700,whiteSpace:"nowrap",flexShrink:0}}>Resend Email</button>
          </div>
          <div style={{fontSize:12,color:"#92400e",fontFamily:"'Inter',sans-serif",marginTop:4}}>
            We sent a verification link to <strong>{props.email}</strong>. Check your inbox (and spam folder). Click the link in that email to activate your account.
          </div>
        </div>
      )}

      {/* Sport tabs + bet type pills - only on sportsbook view */}
      {activeView==="book"&&<div style={{background:"#0f172a",borderBottom:"1px solid rgba(255,255,255,0.07)"}}>
        {isMobile ? <>
          {/* Mobile: bet types as buffer row */}
          <div style={{padding:"6px 12px",display:"flex",gap:4,alignItems:"center",background:"#0a0e1a",borderBottom:"1px solid rgba(255,255,255,0.05)"}}>
            <span style={{fontSize:9,color:"#6b7280",fontFamily:"'Inter',sans-serif",flexShrink:0,marginRight:2}}>Types:</span>
            {(activeSport?.includes("golf") ? [{key:"h2h",label:"ML",color:"#3d9e7a"},{key:"parlay",label:"Parlay",color:"#ff4d6d"}] : [{key:"spreads",label:"Spread",color:"#4d9fff"},{key:"h2h",label:"ML",color:"#3d9e7a"},{key:"totals",label:"Total",color:"#f5b731"},{key:"parlay",label:"Parlay",color:"#ff4d6d"},{key:"teaser",label:"Teaser",color:"#1d4ed8"}]).map(t=>(
              <button key={t.key} onClick={()=>setInfoModal(t.key)} style={{padding:"2px 7px",borderRadius:20,background:"#ffffff",border:"1px solid #e5e7eb",color:t.color,fontSize:9,cursor:"pointer",fontFamily:"'Inter',sans-serif",fontWeight:600,whiteSpace:"nowrap",flexShrink:1}}>
                {t.label}
              </button>
            ))}
          </div>
          {/* Mobile: sport dropdown */}
          <div style={{padding:"6px 14px",background:"#0f172a",position:"relative"}}>
            <button onClick={()=>setSportDropdownOpen(!sportDropdownOpen)} style={{width:"100%",padding:"8px 14px",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:20,color:"#f0f4ff",fontFamily:"'Inter',sans-serif",fontSize:13,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span>{leagueSports.find(s=>s.key===activeSport)?.emoji} {leagueSports.find(s=>s.key===activeSport)?.label}</span>
              <span style={{fontSize:10,color:"#6b7280"}}>{sportDropdownOpen?"▲":"▼"}</span>
            </button>
            {sportDropdownOpen&&(
              <div style={{position:"absolute",top:"calc(100% + 4px)",left:14,right:14,background:"#1a2235",border:"1px solid rgba(255,255,255,0.1)",borderRadius:10,zIndex:50,overflow:"hidden"}}>
                {leagueSports.map(s=>(
                  <button key={s.key} onClick={()=>{setActiveSport(s.key);setSportDropdownOpen(false);}} style={{width:"100%",padding:"10px 14px",background:activeSport===s.key?"rgba(61,158,122,0.15)":"transparent",border:"none",color:activeSport===s.key?"#3d9e7a":"#f0f4ff",fontFamily:"'Inter',sans-serif",fontSize:13,cursor:"pointer",textAlign:"left",display:"flex",alignItems:"center",gap:8}}>
                    <span>{s.emoji}</span>{s.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </> : <>
          {/* Desktop: sport tabs */}
          <div style={{display:"flex",overflowX:"auto",padding:"0 20px",borderBottom:"1px solid rgba(255,255,255,0.05)"}}>
            {leagueSports.map(s=>(
              <button key={s.key} onClick={()=>setActiveSport(s.key)} style={{display:"flex",alignItems:"center",gap:8,padding:"14px 20px",border:"none",cursor:"pointer",background:"transparent",color:activeSport===s.key?"#f0f4ff":"#6b7280",borderBottom:activeSport===s.key?"3px solid #3d9e7a":"3px solid transparent",fontFamily:"'Inter',sans-serif",fontSize:15,fontWeight:activeSport===s.key?700:400,transition:"all 0.15s",whiteSpace:"nowrap"}}>
                <span style={{fontSize:16}}>{s.emoji}</span> {s.label}
              </button>
            ))}
          </div>
          {/* Desktop: bet type pills */}
          <div style={{padding:"8px 20px",display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
            <span style={{fontSize:11,color:"#4b5563",fontFamily:"'Inter',sans-serif",fontWeight:500,marginRight:4}}>Bet types:</span>
            {(activeSport?.includes("golf") ? [{key:"h2h",label:"Moneyline",color:"#3d9e7a"},{key:"parlay",label:"Parlay",color:"#ff4d6d"}] : [{key:"spreads",label:"Spread",color:"#4d9fff"},{key:"h2h",label:"Moneyline",color:"#3d9e7a"},{key:"totals",label:"Total",color:"#f5b731"},{key:"parlay",label:"Parlay",color:"#ff4d6d"},{key:"teaser",label:"Teaser",color:"#1d4ed8"}]).map(t=>(
              <button key={t.key} onClick={()=>setInfoModal(t.key)} style={{padding:"4px 12px",borderRadius:20,background:"#ffffff",border:"1px solid #e5e7eb",color:t.color,fontSize:12,cursor:"pointer",fontFamily:"'Inter',sans-serif",fontWeight:600}}>
                {t.label} <span style={{opacity:0.6}}>?</span>
              </button>
            ))}
          </div>
        </>}
      </div>}

      {/* Views */}
      {activeView==="leaderboard"&&<div style={{flex:1,overflowY:"auto"}}><LeaderboardView leagueId={leagueId} teamId={teamId}/></div>}
      {activeView==="bets"&&<div style={{flex:1,overflowY:"auto"}}><MyBetsView teamId={teamId}/></div>}

      {activeView==="book"&&<div style={{display:"flex",flex:1,overflow:"hidden"}}>
        <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>

          <div style={{flex:1,overflowY:"auto",padding:12}}>
            {loading?(
              <div style={{textAlign:"center",padding:60,color:"#4b5563"}}>
                <div style={{fontSize:24,marginBottom:12,animation:"pulse 1.2s infinite"}}>⟳</div>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:"0.06em"}}>LOADING LINES...</div>
              </div>
            ):games.length===0?(
              <div style={{textAlign:"center",padding:60,color:"#4b5563"}}>
                <div style={{fontSize:32,marginBottom:12}}>🏟</div>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:16,letterSpacing:"0.04em"}}>NO GAMES SCHEDULED</div>
                <div style={{fontSize:13,marginTop:6}}>Check back when the season heats up.</div>
              </div>
            ):games.map(g=><GameCard key={g.id} game={g} slip={slip} onAddBet={handleAddBetWithSlip}/>)}
          </div>
        </div>

        {/* Mobile bet slip mini bar + expandable drawer */}
        {isMobile && slip.length > 0 && (
          <div style={{position:"fixed",bottom:0,left:0,right:0,zIndex:150}}>
            {/* Full drawer when open */}
            {mobileSlipOpen && (
              <div style={{position:"fixed",inset:0,backgroundColor:"rgba(0,0,0,0.5)"}} onClick={()=>setMobileSlipOpen(false)}>
                <div onClick={e=>e.stopPropagation()} style={{position:"absolute",bottom:0,left:0,right:0,backgroundColor:"#ffffff",borderRadius:"20px 20px 0 0",maxHeight:"80vh",display:"flex",flexDirection:"column",boxShadow:"0 -8px 40px rgba(0,0,0,0.4)"}}>
                  <div style={{padding:"14px 20px",borderBottom:"1px solid #e5e7eb",display:"flex",alignItems:"center",justifyContent:"space-between",backgroundColor:"#ffffff",borderRadius:"20px 20px 0 0",flexShrink:0}}>
                    <div style={{fontFamily:"'Inter',sans-serif",fontSize:16,fontWeight:600,color:"#3d9e7a"}}>🎟 Bet Slip</div>
                    <button onClick={()=>setMobileSlipOpen(false)} style={{background:"none",border:"none",fontSize:20,color:"#9ca3af",cursor:"pointer"}}>✕</button>
                  </div>
                  <div style={{overflowY:"auto",flex:1}}>
                    <BetSlip slip={slip} onRemove={handleRemove} credits={credits} teamId={teamId} leagueId={leagueId} onBetPlaced={()=>{handleBetPlaced();setMobileSlipOpen(false);}} activeSport={activeSport}/>
                  </div>
                </div>
              </div>
            )}
            {/* Mini bar always visible at bottom when bets selected */}
            {!mobileSlipOpen && (
              <div onClick={()=>setMobileSlipOpen(true)} style={{backgroundColor:"#3d9e7a",padding:"12px 20px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",boxShadow:"0 -4px 20px rgba(0,0,0,0.3)"}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <span style={{backgroundColor:"rgba(255,255,255,0.25)",borderRadius:12,padding:"2px 10px",fontSize:13,fontWeight:700,color:"#fff"}}>{slip.length}</span>
                  <span style={{fontFamily:"'Inter',sans-serif",fontSize:14,fontWeight:600,color:"#fff"}}>{slip.length===1?"1 bet selected":`${slip.length} bets — parlay`}</span>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontFamily:"'Inter',sans-serif",fontSize:13,color:"rgba(255,255,255,0.8)"}}>View slip ↑</span>
                </div>
              </div>
            )}
          </div>
        )}
        {/* Desktop bet slip */}
        <div className="desktop-only" style={{width:340,borderLeft:"1px solid rgba(255,255,255,0.08)",backgroundColor:"#ffffff",display:"flex",flexDirection:"column",flexShrink:0,borderRadius:"12px",overflow:"hidden"}}>
          {/* Slip header */}
          <div style={{padding:"18px 20px",borderBottom:"1px solid #e5e7eb",display:"flex",alignItems:"center",justifyContent:"space-between",backgroundColor:"#ffffff",flexShrink:0}}>
            <div style={{fontFamily:"'Inter',sans-serif",fontSize:16,fontWeight:500,color:"#3d9e7a",letterSpacing:"0.02em"}}>🎟 Bet Slip</div>
            {slip.length>0&&<div style={{display:"flex",alignItems:"center",gap:8}}>
              <span style={{background:"#3d9e7a",color:"#fff",fontSize:11,fontWeight:700,width:22,height:22,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Inter',sans-serif"}}>{slip.length}</span>
              <button onClick={()=>setSlip([])} style={{background:"none",border:"none",color:"#9ca3af",fontSize:12,cursor:"pointer",fontFamily:"'Inter',sans-serif",fontWeight:500}}>Clear</button>
            </div>}
          </div>
          {/* Slip content - no extra padding wrapper */}
          <BetSlip slip={slip} onRemove={handleRemove} credits={credits} teamId={teamId} leagueId={leagueId} onBetPlaced={handleBetPlaced} activeSport={activeSport}/>
        </div>
      </div>}
    </div>
  </>;
}
